import { DbgPaths } from "#/utils/Paths"
import { Link } from "@carrotfertility/carotene-core"
import React from "react"

export const QmesLink = ({ children }: { children: React.ReactNode }) => {
  return (
    <Link target="_blank" href={DbgPaths.QUALIFIED_MEDICAL_EXPENSES} color="inherit">
      {children}
    </Link>
  )
}
